
type BusinessInfoProps = {
  businessInfo: {
    business_name?: string | null;
    business_address?: string | null;
  };
};

function PaymentBusinessInfo({ businessInfo }: BusinessInfoProps) {
  return (
     <div className="w-full max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow p-4 flex flex-col gap-1 border border-gray-100">
              <h2 className="text-2xl font-bold">Business Information</h2>
              <div className="w-full h-px mb-3"></div>
              <div className="flex flex-col">
                {businessInfo.business_name && (
                  <div className="text-base font-medium text-gray-900 mb-1">
                    {businessInfo.business_name}
                  </div>
                )}
                {businessInfo.business_address && (
                  <div className="text-base text-gray-900 mt-1">
                    {businessInfo.business_address}
                  </div>
                )}
              </div>
            </div>
          </div>
  )
}

export default PaymentBusinessInfo